import React from "react";

import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Container from "@mui/material/Container";

const Sobre = () => {
	return (
		<>
			{/* Informações Pessoais */}
			<section>
				<h1 className="m-5">Sobre Nós</h1>

				<div className="my-5 text-center">
					<Grid
						container
						spacing={2}
						padding={3}
						columnSpacing={{ xs: 1, sm: 2, md: 3 }}
						className="d-flex justify-content-center"
					>
						<Grid item xs={12} sm={5}>
							<Paper variant="outlined" className="p-3">
								<h3>Anderson de Alencar Barros</h3>
								<p>
									Graduando em Engenharia de Computação,
									Bolsista e Desenvolvedor
								</p>
								<address>
									{/* <div className="d-flex justify-content-center">
                                        <LinkedInIcon 
                                            color="primary"
                                        />
                                        <GitHubIcon 
                                        color="primary"
                                        />
                                    </div> */}
								</address>
							</Paper>
						</Grid>
						<Grid item xs={12} sm={6}>
							<Paper variant="outlined" className="p-3">
								<h3>Vivianni Marques Leite dos Santos</h3>
								<p>Docente e Orientadora</p>
								<address>
									{/* <div className="d-flex justify-content-center">
                                        <LinkedInIcon color="primary" />
                                        <GitHubIcon  color="primary" />
                                    </div> */}
								</address>
							</Paper>
						</Grid>
					</Grid>
				</div>
			</section>

			{/* Referências */}
			<section>
				<h1 className="m-5">Referências</h1>

				<Container className="container-fluid m-auto" id="ref-1">
					<cite>
						JUNIOR, Emanoel Coelho Benevides; DE LIMA, Nyegge
						Vittória Martins; DOS SANTOS, Vivianni Marques Leite.{" "}
						<b>
							{" "}
							Diagnostics and action plans for innovation in small
							scale industries of Juazeiro/BA
						</b>
						. Revista Geintec-Gestao Inovacao E Tecnologias, v. 9,
						n. 2, p. 4876-4892, 2019.
					</cite>
				</Container>
			</section>
		</>
	);
};

export default Sobre;
